/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Portal_Invite_UrlInputs */

const cs_client_portal_invite_url = /** @type {(inputs: Client_Portal_Invite_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkaz pozvánky (sdílejte bezpečně)`)
};

const en_client_portal_invite_url = /** @type {(inputs: Client_Portal_Invite_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite link (share securely)`)
};

/**
* | output |
* | --- |
* | "Invite link (share securely)" |
*
* @param {Client_Portal_Invite_UrlInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_portal_invite_url = /** @type {((inputs?: Client_Portal_Invite_UrlInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Portal_Invite_UrlInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_portal_invite_url(inputs)
	return cs_client_portal_invite_url(inputs)
});